export const palette = {
  green: '#689f38',
  lightGreen: '#cddc39',

  blue: '#1976d2',
  lightYellow: 'rgba(255, 255, 192, 1)',

  pink: '#ff4081',
};
